import React from 'react'
import styled from 'styled-components'
import { lightBlue } from '../../assets/colors'
import { Montserrat } from '../../assets/fonts'
import { pgaComTld } from '../utils'

export const StyledLink = styled.p`
  color: ${lightBlue};
  font-family: ${Montserrat};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
`

const MsrHistoryLink = () => {
  const PDR_HISTORY_URL = `https://${pgaComTld}/member/pdr/pdr-history`

  const handleToggle = () => window.open(PDR_HISTORY_URL)

  return (
    <>
      <StyledLink onClick={handleToggle}>View All PDR History <i className='fa fa-angle-right' /></StyledLink>
    </>
  )
}

export default MsrHistoryLink
